/* eslint-disable no-unused-vars */
export enum UIDropdownButtonVariants {
  white = 'white',
  green = 'green',
  greenDropdown = 'greenDropdown',
  commonDropdown = 'commonDropdown',
  whiteDropdownRounded = 'whiteDropdownRounded',
};
